import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useParams } from "react-router-dom";
import { FETCH_GTM_PROJECT } from "./graphql";
import GTMProjectForm from "./GTMProjectForm";

const GTMProjectDetail = () => {
  const { id } = useParams();
  const { loading, error, data, refetch } = useQuery(FETCH_GTM_PROJECT, {
    variables: { id },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const sortedSuppliers = [...data.suppliers].sort((a, b) =>
    a.name.localeCompare(b.name),
  );

  return (
    <GTMProjectForm
      originalGTMProject={data.gtmProject}
      allMaterials={data.allMaterials}
      suppliers={sortedSuppliers}
      allLabTestStandards={data.allLabTestStandards}
      refetch={refetch}
    />
  );
};

export default GTMProjectDetail;
